import React, { useContext } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import { Flex, Spacer } from '@zillow/constellation';
import { Tag } from '@zillow/zrs-comet';

import { getTagTypeByKey, STATUS_KEY } from 'app/shared/utils/statusTagUtils';
import propertyUtils from 'app/shared/utils/propertyUtils';
import { RMWContext } from 'app/shared/providers/RMWContext';
import EditPropertyTypeMenu from 'app/shared/components/EditPropertyTypeMenu';

import {
    StyledAddressDetails,
    StyledDesktopStatusSpacer,
    StyledStreetText,
    StyledLink,
    StyledIconChevronLeft,
    StyledCityStateText,
} from './StyledComponents';

const propTypes = {
    currentSection: PropTypes.string.isRequired,
    isScrolledMobile: PropTypes.bool.isRequired,
};

const AddressDetails = ({
    currentSection,
    isScrolledMobile,
}) => {
    const { paths } = useContext(RMWContext);

    const {
        address,
        status,
    } = useSelector(state => state.properties.propertyOverview);

    const { PROPERTY_DETAILS_OVERVIEW } = STATUS_KEY;

    const {
        formattedStreet,
        formattedCityStateZip,
    } = propertyUtils.formatAddress(address);

    return (
        <StyledAddressDetails>
            <Flex
                display="flex"
                flexDirection="row"
                alignItems="center"
            >
                <StyledLink
                    to={paths.propertiesPage}
                    isScrolledMobile={isScrolledMobile}
                >
                    <StyledIconChevronLeft size="xs" />
                </StyledLink>
                <StyledStreetText
                    isScrolledMobile={isScrolledMobile}
                    as="h4"
                    fontType="h4"
                >
                    {formattedStreet}
                </StyledStreetText>
                <Spacer marginLeft="sm" paddingRight="xs">
                    <Flex display="flex">
                        <EditPropertyTypeMenu currentSection={currentSection} />
                    </Flex>
                </Spacer>
            </Flex>
            <StyledCityStateText
                isScrolledMobile={isScrolledMobile}
                fontType="bodySmallHeading"
                as="p"
            >
                {formattedCityStateZip}
            </StyledCityStateText>
            <StyledDesktopStatusSpacer>
                <Tag
                    appearance={getTagTypeByKey(PROPERTY_DETAILS_OVERVIEW, status)}
                    size="lg"
                >
                    {status}
                </Tag>
            </StyledDesktopStatusSpacer>
        </StyledAddressDetails>
    );
};

AddressDetails.propTypes = propTypes;

export default AddressDetails;
